import React, { useState, useEffect } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useIntl } from '@atlassian/jira-intl';
import type { CardId } from '../../../model/types.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';
import {
	getCards,
	isCardSelected,
	shouldRenderRichElements,
} from '../../../state/selectors/cards/index.tsx';
import FieldSyncAssignee from './field-sync-assignee/index.tsx';
import FieldSyncOriginalEstimate from './field-sync-original-estimate/index.tsx';
import FieldSyncParent from './field-sync-parent/index.tsx';
import FieldSyncPriority from './field-sync-priority/index.tsx';
import FieldSyncStatus from './field-sync-status/index.tsx';
import FieldSyncStoryPoint from './field-sync-story-point/index.tsx';
import FieldSyncSummary from './field-sync-summary/index.tsx';

type Props = {
	cardId: CardId;
};

const FieldSync = ({ cardId }: Props) => {
	const shouldSync = useBacklogSelector(
		(state) => isCardSelected(state)(cardId) || shouldRenderRichElements(state, { cardId }),
	);

	const card = useBacklogSelector((state) => getCards(state)[String(cardId)]);

	const intl = useIntl();

	// don't unmount syncing if once enabled
	const [sync, setSync] = useState(shouldSync);
	useEffect(() => {
		if (!sync && shouldSync) setSync(true);
	}, [sync, shouldSync]);

	// don't sync if card is not fetched from state correctly
	if (!card) {
		return null;
	}

	return (
		<>
			{(sync || shouldSync) && (
				<>
					<FieldSyncOriginalEstimate card={card} intl={intl} />
					<FieldSyncStoryPoint card={card} />
					<FieldSyncStatus card={card} />
					<FieldSyncAssignee card={card} />
					{!ff('relay-migration-issue-fields-summary_eog1v') && <FieldSyncSummary card={card} />}
					<FieldSyncParent card={card} />
					<FieldSyncPriority card={card} />
				</>
			)}
		</>
	);
};

export default FieldSync;
